import { Injectable, inject } from '@angular/core';
import { ProductModel, ProxyService } from '@seahorse/domain';
import { Observable } from 'rxjs';
import { ObjectDefinitionsDataService } from './object-definitions-data.service';

@Injectable({
  providedIn: 'root',
})
export class ProxyServices extends ProxyService {
  organisationId: string;
  products: ProductModel[] = [];

  private _objectDefinitionsDataService = inject(ObjectDefinitionsDataService);

  getData(): Observable<boolean> {
    return new Observable<boolean>((subscriber) => {
      this._objectDefinitionsDataService
        .getByOrganization(this.organisationId)
        .subscribe(
          (result) => {
            this.objectDefinitions = result.result;
            this.setDefaultKeyMappings();
            subscriber.next(true);
            subscriber.complete();
          },
          () => {
            subscriber.next(false);
            subscriber.complete();
          }
        );
    });
  }
}
